import { Tasks } from 'src/model/db/tasks';

const pageBuyCourseMixin = {
    data () {
        return {
            loading: false,
            course: undefined,
            tariffs: undefined,
            activeTariff: undefined,
            extraPrice: 0,
            extraTariffs: undefined,
            // activeExtraTariff: undefined,
        };
    },
    methods: {
        async load () {
            this.loading = true;
            const { alias } = this.$route.params;
            if (alias) {
                this.courseId = await Tasks.locateCourseId(alias);
            }

            if (this.$refs.bar) {
                this.$refs.bar.start();
            }
            await this.$db.tasks.getCoursePrices(this.courseId).then((r) => {
                this.tariffs = r;
            });
            await this.$db.tasks.getCourses(`id = '${this.courseId}'`).then((r) => {
                // eslint-disable-next-line prefer-destructuring
                this.course = r[0];
            });
            this.loadExtraTariffs();
            if (this.$refs.bar) {
                this.$refs.bar.stop();
            }
            this.loading = false;
        },
        loadExtraTariffs () {
            this.extraPrice = 0;
            this.extraTariffs = undefined;
            const f = this.tariffs.filter((t) => t.tariff === '0')[0];
            if (f) {
                this.extraPrice = parseFloat(f.price);
            }
            const et = [];
            let price = this.extraPrice * 0.5;
            et.push({
                type: 0,
                description: `${price} ₽ для студентов, бюджетников, малообеспеченных граждан, родителей с детьми до 3х лет, с заработной платой выше среднего по региону`,
                price,
            });
            price = this.extraPrice * 0.25;
            et.push({
                type: 1,
                description: `${price} ₽ для безработных, не стоящих на учете в центре занятости и родителей с детьми до 3х лет, с заработной платой ниже среднего по региону`,
                price,
            });

            price = this.extraPrice * 0;
            et.push({
                type: 2,
                description: `${price} ₽ для безработных, стоящих на учете в центре занятости для инвалидов`,
                price,
            });

            this.extraTariffs = et;
        },
    },
};

export default pageBuyCourseMixin;
